import { handleRequest } from '@/api/core/requestUtils';
import type { MacroParameterRequest, MacroParameterResponse, MacroReachResponse } from '@/types/macro';

const withSignal = (
    request: MacroParameterRequest,
    signal?: AbortSignal
): MacroParameterRequest & { signal?: AbortSignal } => (signal ? { ...request, signal } : request);

export const getMacroParameters = (
    request: MacroParameterRequest,
    signal?: AbortSignal
): Promise<MacroParameterResponse> => handleRequest('post', '/dashboard/macro_parameters', withSignal(request, signal));

export const getMacroReach = (request: MacroParameterRequest, signal?: AbortSignal): Promise<MacroReachResponse> =>
    handleRequest('post', '/dashboard/macro_reach', withSignal(request, signal));
